/**
 * Tizen model information and used OS version
 * https://developer.samsung.com/smarttv/develop/specifications/tv-model-groups.html
 *
 * NOTE: The years are a rough guideline and it's been the case in the past that, for example,
 * a 2017 model has had a version of Tizen greater than 3.0. It's rare but possible.
 */
export var TizenVersion;
(function (TizenVersion) {
    TizenVersion["Tizen-2.3"] = "2.3";
    TizenVersion["Tizen-2.4"] = "2.4";
    TizenVersion["Tizen-3"] = "3.0";
    TizenVersion["Tizen-4"] = "4.0";
    TizenVersion["Tizen-5"] = "5.0";
    TizenVersion["Tizen-5.5"] = "5.5";
    TizenVersion["Tizen-6"] = "6.0";
    TizenVersion["Tizen-6.5"] = "6.5";
    TizenVersion["Tizen-7"] = "7.0";
})(TizenVersion || (TizenVersion = {}));
// Until we move all premium model matching to core-video-config (i.e. device
// object with isModelPremium inside the core-video-config) this needs to
// be kept in sync with the list in tizen-device-matchers.ts (core video SDK JS)
const TizenPremiumModels = [
    /^QCQ(70|80|83|85|88|8X|90|95|9X|S90|S95|S9X).*$/,
    /^G(75NC|85NC|95SC).*$/,
    /^M(70C|80C).*$/,
    /^MCWS1$.*$/,
    /^QBQ(?:9[0-9]{2}|8[0-5]0|100).*$/,
    /^Q[ABTMN]Q[DSX789].*$/,
    /^QRQ[6789].*$/,
    /^Q[MN]Q.*$/,
    /^QMS.*$/,
    /^LS[TR].*$/,
    /^LS0[1345].*$/,
    /^M[8ABLT].*$/,
    /^URU80.*$/,
    /^UNU(74|75|76|80|85).*$/,
    /^UM[L,Q,U].*$/,
    /^UL.*$/,
    /^G.*$/,
    /^UKS.*$/,
    /^UKU(9|66|65|64).*$/,
];
// Checks first for certain basic models.
// This is intended to keep the TizenPremiumModels regex fairly simple.
// Also: Samsung QNQ6F Premium Chipset - Low production performance, struggles to reach 60FPS on NFL.
// Should be treated as non premium.
const TizenBasicModels = /^(LS0[35][a-zA-Z][SL]|QNQ6F)$/;
export function isModelPremium(tizenInfo) {
    if (TizenBasicModels.test(tizenInfo.deviceModel)) {
        return false;
    }
    for (const modelRegex of TizenPremiumModels) {
        if (modelRegex.test(tizenInfo.deviceModel)) {
            return true;
        }
    }
    if (/premium/i.test(tizenInfo.deviceModelCode)) {
        return true;
    }
    return false;
}
/**
 * @deprecated operation in the future will no longer be exported and the respective information should be obtained using the current device
 * TODO https://gspcloud.atlassian.net/browse/LTV-12182
 * Check if the device uses TizenOS as well as having the specific version received.
 */
export function checkIsTizenVersion(deviceInfo, tizenVersionToCheckAgainst) {
    if (deviceInfo.operatingSystemName !== 'Tizen') {
        return false;
    }
    const deviceVersion = new SamsungFw(deviceInfo.deviceVersion);
    return `${deviceVersion.fwVersion.major}.${deviceVersion.fwVersion.minor}` === tizenVersionToCheckAgainst;
}
export class SamsungFw {
    fwVersion;
    constructor(versionString) {
        this.fwVersion = this.parseVersionString(versionString);
    }
    isNewerOrEqualTo(compareVersion) {
        if (this.fwVersion.major !== compareVersion.fwVersion.major) {
            return this.fwVersion.major >= compareVersion.fwVersion.major;
        }
        return this.fwVersion.minor >= compareVersion.fwVersion.minor;
    }
    parseVersionString(fullVersion) {
        const versionString = fullVersion?.split('-').pop() || '';
        const splitRelease = versionString.split('.');
        return {
            major: parseInt(splitRelease[0], 10) || 0,
            minor: parseInt(splitRelease[1], 10) || 0,
        };
    }
}
//# sourceMappingURL=tizen-utils.js.map